import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import AdminIcon from '@mui/icons-material/Security'

import SubMenu, { MenuItem, SubMenuWithResourcesProps } from 'dash/layout/menu/sub_menu'

type UserMenuProps = SubMenuWithResourcesProps

export const UserMenu: FC<UserMenuProps> = ({ dense, onMenuClick, resources, sidebarIsOpen }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [menuItems, setMenuItems] = useState<MenuItem[]>([])

  useEffect(() => {
    if (resources) {
      setMenuItems(resources)
    }
  }, [resources])

  return (
    <SubMenu
      dense={dense}
      handleToggle={() => setIsOpen(!isOpen)}
      icon={<AdminIcon />}
      // isOpen={isOpen}
      isOpen
      menuItems={menuItems}
      name="User"
      onMenuClick={onMenuClick}
      sidebarIsOpen={sidebarIsOpen}
      subMenuKey="user"
    />
  )
}
